@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.popup {
  background-color: var(--grey-000);
  box-shadow: 0 4px 2px 0 rgb(from var(--grey-900, 0.1) r g b / 0.2);
  border-radius: @space-8;
  position: fixed;
  width: 360px;
  bottom: @space-12;
  right: @space-12;
  display: flex;
  padding: @space-16;
  flex-direction: column;
  align-items: flex-start;
  gap: @space-16;
  align-self: stretch;
  z-index: 3;
}

.title {
  font-weight: 700;
  line-height: 28px;
}

.title-container {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.title-button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.button-container {
  display: flex;
  align-self: stretch;
}

.activate-button {
  flex: 1 0 0;
  height: 40px;
}

.terms-container {
  gap: @space-8;
}

.term-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: @space-8;
  padding-left: @space-24;
}

.terms-link-icon {
  width: 16px;
}

.term-checkbox {
  height: unset;
  span.term-checkbox-inner {
    &:before {
      margin: 4px 10px 0 0; // Intentionally not using @space for 10px to align checkbox text
    }
    &:after {
      top: 6px;
    }
  }

  & > * {
    input[type='checkbox'] {
      height: 18px;
    }
  }
}

.label-provider-logo {
  gap: @space-8;

  > img,
  > svg {
    height: 40px;
    width: 40px;
  }
}
